<div>
    <div style="width: 100%; height: 30px; background-color: var(--primary); border-bottom: 3px solid #9DB2BF; ">
        <div class="container" style="max-width: 100% !important; color: white;">
            <div fxLayout="row">
                <div class="center-vertical" class="profile" fxFlex="10%"><img src="assets/logos/icon_enovsky.png"></div>
                <div class="center-vertical" fxFlex="30%" style="white-space: nowrap;">
                    {{taskLabels[currentTask]}} (P{{projectInfos['id']}}: {{projectInfos['project_name']}})
                </div>
                <div class="center-vertical" fxFlex="40%">
                    <nav *ngIf="!isEpanel" style="z-index: 10000;">
                        <ul style="margin: 0; display: flex;" fxLayoutAlign="center center"> 
                            <li> <mat-icon (click)="splittingService.showSplitting()" style="cursor: pointer; margin-right: 20px; font-size: 20px;" [ngClass]="splittingActive? 'page-active': 'page-inactive'" aria-hidden="false" fontIcon="content_cut"></mat-icon>
                                <ul> <li>Split</li></ul> 
                            </li>
                            <li> <mat-icon (click)="splittedService.showSplitted()" style="cursor: pointer; margin-right: 20px;" [ngClass]="splittedActive? 'page-active': 'page-inactive'" aria-hidden="false" fontIcon="horizontal_split"></mat-icon>
                                <ul> <li>Splitted</li></ul> 
                            </li> 
                             
                           <li> <mat-icon (click)="classifyService.showClassified()" style="cursor: pointer; margin-right: 20px;" [ngClass]="classifiedActive? 'page-active': 'page-inactive'" aria-hidden="false" fontIcon="hive"></mat-icon>
                                <ul> <li>Classified</li></ul>     
                            </li> 
                            <li *ngIf="userInfos['privilege'] >= 3"> <mat-icon style="color: white; cursor: pointer; margin-right: 20px; font-size: 20px;" aria-hidden="false" fontIcon="more_vert" title="Settings"></mat-icon>
                                <ul style="right: -4px;"> 
                                    <li (click)="classifyService.deleteProject('archive_project')" style="white-space: nowrap; display: flex; ">
                                        <div>Archive Project</div>
                                    </li>
                                    <li (click)="classifyService.deleteProject('delete_project_without_ressource')" style="white-space: nowrap; display: flex; ">
                                        <div>Delete Project withtout Ressources</div>
                                    </li>
                                    <li (click)="classifyService.deleteProject('delete_project_with_ressource')" style="white-space: nowrap; display: flex;">
                                        <div>Delete Project with Ressources</div>
                                    </li>
                                </ul> 
                            </li> 
                        </ul> 
                    </nav>
                </div>
                <div fxFlex="20%" style="display: flex; align-items: center;">
                    <div style="margin-left: auto; display: flex;">
                        <mat-icon *ngIf="!isEpanel && (splittingActive || splittedActive)" (click)="buildProcess()" style="color: lightcyan; cursor: pointer; margin-right: 40px;" aria-hidden="false" fontIcon="play_circle" title="Build"></mat-icon>
                        <mat-icon *ngIf="isEpanel" (click)="buildProcess()" style="color: white; cursor: pointer; margin-right: 40px;" aria-hidden="false" fontIcon="download" title="Download"></mat-icon>
                        <mat-icon style="color: white; cursor: pointer;" aria-hidden="false" fontIcon="close" title="Close" (click)="onClose()"></mat-icon>
                    </div>
                </div>
            </div>
        </div>
        <mat-progress-bar *ngIf="inProgress" class="progress_bar" mode="buffer"></mat-progress-bar>
        
    </div>
    <div *ngIf="splittingActive" class="show_content resizable-container-vertical">
        <div class="content_to_split resizable-zone-vertical" id="left-vertical">
            <div fxLayout="row" style="background-color: #446994;">
                <nav style="z-index: 10000;">
                    <ul style="margin: 0;" fxLayoutAlign="center center"> 
                        <li> <mat-icon (click)="splittingService.expandCropSplitting()" style="cursor: pointer; margin-right: 20px; font-size: 20px;" [ngClass]="splittingActive? 'page-active': 'page-inactive'" aria-hidden="false" fontIcon="vertical_split"></mat-icon>
                            <ul> <li style="white-space: nowrap;">Load external contents</li></ul> 
                            <div *ngIf="showExternalContent">
                                <app-float-window [externalDataContent]="externalDataContent" (closeExternal)="closeExternal($event)" (callBackEvent)="callBackEventEmiter($event)"></app-float-window>
                            </div>
                        </li>
                    </ul> 
                </nav>
            </div>
            <div class="show_content_to_split"> </div>
        </div>
        <div class="resizable-bar-vertical" id="drag-vertical"></div>
        <div class="content_split_resume resizable-zone-vertical" id="right-vertical">
            <div fxLayout="row" style="display: flex; background-color: #446994;">
                <mat-icon (click)="splittingService.autoOrderingSplits()" style="cursor: pointer; margin: auto; font-size: 24px; color: white" aria-hidden="false" fontIcon="format_list_numbered"></mat-icon>
                <mat-icon (click)="splittingService.sendValidContentToEnd()" style="cursor: pointer; margin: auto; font-size: 24px; color: white" aria-hidden="false" fontIcon="sort"></mat-icon>
            </div>
            <div class="show_content_split_resume"></div>
        </div>
    </div>
    <div *ngIf="splittedActive" class="pages show_content_splitted" style="overflow: auto;"> </div>
    <div *ngIf="classifiedActive">
        <app-project-classify [userInfos]="userInfos" [classifyData]="classifyData" [projectInfos]="projectInfos" [platformInfos]="platformInfos"></app-project-classify>
    </div>
</div>